/**
 * Given an object with `firstName` and `lastName` values (e.g. a user,
 * contact, eventContact, or similar entity), return the full name.
 *
 * @param {Object} entity
 * @return {String|undefined}
 */
const getFullName = (entity = {}) => {
    if (entity.firstName && entity.lastName) {
        return `${entity.firstName} ${entity.lastName}`;
    }

    if (entity.firstName) {
        return entity.firstName;
    }

    return undefined;
};

export default getFullName;
